<template>
  <div class="course">
    <div class="breadcrumb">
      <span>{{currentCourse.name}}</span>
    </div>
    <p class="tip-line">{{currentCourse.describe}}</p>
    <el-row :gutter="10">
      <el-col :span="8">
        <p class="title">选择单元</p>
        <div class="data-list unit">
          <ul>
            <li
                v-for="unit in unitList"
                :key="unit.id"
                :class="{selected: currentUnitId === unit.id}"
                @click="selectUnit(unit)"
            >
              <p class="unit-name" :title="unit.name">
                {{ unit.name }}
                <el-tag v-if="unit.isExperience" size="mini">快速体检</el-tag>
              </p>
              <span
                  class="status"
                  :class="{
                    finished: unit.status === 1,
                    underway: unit.status === 2,
                  }"
              >
                <template v-if="currentCourse.type === 'BKW'">
                  <template v-if="unit.status === 0">未完成</template>
                  <template v-else-if="unit.status === 1">已完成</template>
                  <template v-else>进行中</template>
                </template>
                <template v-else>
                  <template v-if="unit.status === 0">未完成</template>
                  <template v-else-if="unit.status === 3">已达标</template>
                <template v-else>{{unit.progress}}%</template>
                </template>
              </span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="currentCourse.type === 'BKW' ? 16 : 12">
        <p class="title">{{currentUnit.name}}</p>
        <div class="data-list module">
          <ul v-if="practiceList.length && currentCourse.type === 'BKW'">
            <li
                v-for="module in practiceList"
                :key="module.id"
            >
              <p class="module-name">{{ module.name }}</p>
              <div class="operation">
                <el-button :type="module.view.isFinished ? 'primary' : 'info'"
                           size="mini"
                           plain
                           round
                           @click="startPlay(module.view, 'view')"
                >
                  新学
                </el-button>
                <el-button :type="module.review.isFinished ? 'primary' : 'info'"
                           size="mini"
                           plain
                           round
                           @click="startPlay(module.review, 'review')"
                >
                  复习
                </el-button>
              </div>
            </li>
          </ul>
          <p class="empty" v-else-if="!practiceList.length && currentCourse.type === 'BKW'">暂无数据</p>
          <div class="bdc-module" v-else-if="currentCourse.type === 'BDC'">
            <div class="left" @click="playWord('bdc_learn')">
              <span>开始学习</span>
            </div>
            <div class="right">
              <div
                class="item"
                @click="playWord('bdc_exam')">
                <span>智能测试</span>
              </div>
              <div class="item"
                @click="playWord('bdc_review')">
                <span>自主复习</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="4" v-if="currentCourse.type === 'BDC'">
        <div class="bdc-btn">
          <div @click="playWord('bdc_wrong')" class="el-button">
            <i class="el-icon-edit"></i>
            本书易错词
          </div>
          <div class="el-button" @click="playWord('bdc_book_exam')">
            <i class="el-icon-star-off"></i>
            本书测试
          </div>
          <div class="el-button" @click="playWord('bdc_all_exam')">
            <i class="el-icon-tickets"></i>
            一测到底
          </div>
        </div>
      </el-col>
    </el-row>
    <van-bkw-dialog
        ref="bkw-dialog"
        :navigation="quizData.navigation"
        :title="quizData.title"
        :subtitle="quizData.subtitle"
        :description="quizData.description"
        :type="quizData.type"
        :learn-mode="learnMode"
        :status="quizData.status"
        :play-times="quizData.playTimes"
        :quizzes="quizzes"
        @submit="submitQuizResult"
        @continue="handleContinue"
        @refresh="getUnitList"
    />
    <van-bdc-dialog
      ref="bdc-dialog"
      :navigation="quizData.navigation"
      :title="quizData.title"
      :course-id="courseId"
      :unit-id="currentUnitId"
      :quiz-type="quizData.type"
      :subtitle="quizData.subtitle"
      :description="quizData.description"
      :status="quizData.status"
      :is-exam="isExam"
      :exam-type="wordExamType"
      :quizzes="quizzes"
      :book-mode="quizData.bookMode"
      @replay="replay"
      @show-report="showBdcReport"
      @close="quizData = {}"
      @continue="handleContinue"
      @refresh="getUnitList"
      @submit="submitQuizResult" />
    <van-dialog
      class="word-exam-dialog"
      ref="word-exam-dialog"
      :is-disable-close="true"
      :is-show-footer="true">
      <van-quizzes-toolbar
        slot="title"
        :title="wordExamInfo.navigation"
        :is-forced="false"
        @close="closeDialog" />
      <div class="word-centent">
        <div class="name">{{wordExamInfo.title}}</div>
        <div class="hint">请选择测试内容</div>
        <div class="radio-grop">
          <el-radio-group class="radio-group" v-model="wordExamType">
            <el-radio
              v-for="(type, index) in wordExamInfo.list"
              :key="index"
              :label="type.label">
              <template v-if="type.label === 'day_learn'">今日新学（{{type.value}}个）</template>
              <template v-else-if="type.label === 'already_unit_learn'">
                已学（{{type.value}}个）
              </template>
              <template v-else>单元卷（{{type.value}}个）</template>
              <template></template>
              <template></template>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="btn-control">
          <el-button
            :disabled="wordExamCount === 0 || !currentWordExam.status"
            @click="onlineWordExam('online')"
            type="primary">在线测试</el-button>
          <template v-if="wordExamType !== 'all_unit_learn'">
            <el-button
              :disabled="wordExamCount === 0 || !currentWordExam.status"
              @click="selectDownloadExamType('download')"
              type="primary">下载试卷</el-button>
          </template>
          <template v-else>
            <el-button
              :disabled="wordExamCount === 0"
              @click="selectDownloadExamType('download_learn_before')"
              type="primary">下载学前测试卷</el-button>
            <el-button
              :disabled="wordExamCount === 0"
              @click="selectDownloadExamType('download_learn_after')"
              type="primary">下载学后测试卷</el-button>
            <el-button
              :disabled="wordExamCount === 0"
              @click="onlineWordExam('unit_dictation')"
              type="primary">单元听写</el-button>
          </template>
        </div>
      </div>
    </van-dialog>
    <el-dialog
      class="down-exam-dialog"
      title="下载试卷"
      :visible.sync="downloadExamDialogVisible"
      width="510px">
      <div class="header">请选择下载内容</div>
      <el-radio-group
        v-model="checkedBDCDownloadExamMode">
        <el-radio
          v-for="(item, index) in BDCExamModeList"
          :label="item.value"
          :key="index">{{item.label}}</el-radio>
      </el-radio-group>
      <div class="footer-title">请选择下载方式</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportExamExcel">下载到本地</el-button>
        <el-button type="primary" @click="downloadWordExam">直接打印</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="exam-dialog"
      title="在线测试"
      :visible.sync="isShowExamMode"
      width="510px">
      <div class="header">测试类型：</div>
      <el-checkbox-group
        v-model="checkedBDCExamMode"
        :min="1">
        <el-checkbox
          v-for="(item, index) in BDCExamModeList"
          :label="item.value"
          :key="index">{{item.label}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowExamMode = false">取消</el-button>
        <el-button type="primary" @click="confirmOnlineExamMode">确定</el-button>
      </span>
    </el-dialog>
    <van-certificate
      :info="reportInfo"
      v-show="isShowBdcReport"
      :results="reportResults"
      :is-replay="!!reportResults.length"
      @close="isShowBdcReport = false"
    />
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Dialog,
  Radio,
  RadioGroup,
  CheckboxGroup,
  Checkbox,
  Tag,
} from 'element-ui';
// import audioPlayer from 'vanthink-components/utils/audio-player';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanBkwDialog from '@/components/quizzes/bkw/Dialog.vue';
import VanBdcDialog from '@/components/quizzes/bdc/Dialog.vue';
import VanDialog from '@/components/common/Dialog.vue';
import VanCertificate from '@/components/quizzes/bdc/Certificate.vue';
import utils from '@/services/utils';
// import excel from '@/services/excel';
import exportExcel from '@/services/exportExcel';
import api from '@/api/graphql/englishCourse';
// import services from '@/api/graphql/learning';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
    ElButton: Button,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
    ElDialog: Dialog,
    ElCheckboxGroup: CheckboxGroup,
    ElCheckbox: Checkbox,
    ElTag: Tag,
    VanBkwDialog,
    VanBdcDialog,
    VanDialog,
    VanQuizzesToolbar,
    VanCertificate,
  },
  data() {
    return {
      currentUnitId: 0,
      unitList: [],
      modules: {}, // class array
      quizData: {},
      learnMode: '',
      wordExamInfo: {},
      wordExamType: '',
      wordExamCount: 0,
      isShowExamMode: false,
      checkedBDCExamMode: [],
      checkedBDCDownloadExamMode: '',
      BDCExamModeList: [],
      currentWordExam: {},
      downloadExamDialogVisible: false,
      downloadExamType: null,
      currentCourse: {},
      isShowBdcReport: false,
      reportInfo: {},
      reportResults: [],
    };
  },
  provide() {
    return {
      getUnitList: () => this.unitList,
      getCurrentUnitId: () => this.currentUnitId,
    };
  },
  watch: {
    $route() {
      // reset current unitId id
      this.currentUnitId = 0;
    },
    currentCourse() {
      if (this.currentCourse.type !== 'DS') {
        this.getUnitList();
      }
    },
    wordExamType() {
      this.wordExamInfo.list.forEach((item) => {
        if (item.label === this.wordExamType) {
          this.wordExamCount = item.value;
          this.currentWordExam = item;
        }
      });
    },
  },
  computed: {
    isExam() {
      return this.quizData.type === 'online'
        || this.quizData.type === 'book_learn'
        || this.quizData.type === 'learn_before_test'
        || this.quizData.type === 'learn_after_test'
        || this.quizData.type === 'unit_dictation';
    },
    courseId() {
      return Number(this.$route.params.courseId || 0);
    },
    practiceList() {
      return this.modules[this.currentUnitId] || [];
    },
    currentUnit() {
      return utils.Array.find(this.unitList, { id: this.currentUnitId }, 'id') || {};
    },
    quizzes() {
      if (this.quizData.quizzes) {
        // 冻结对象
        return this.quizData.quizzes.map(quiz => Object.freeze(quiz));
      }
      return [];
    },
  },
  methods: {
    hint() {
      utils.message('单元听写即将上线，快去背单词准备迎接挑战吧！');
    },
    selectUnit({ id }) {
      if (this.currentCourse.type === 'BKW') {
        this.getModuleList(id);
      } else {
        this.currentUnitId = id;
      }
    },
    startPlay({ id, isFinished, isCompleted }, type) {
      this.learnMode = type;
      if (!isFinished) {
        if (type === 'view') {
          utils.error('请先完成上一篇文章的“新学”');
        } else {
          utils.error('请先完成本篇文章的“新学”');
        }
        return;
      }
      this.getQuizData({
        moduleId: id,
        isCompleted,
        type,
      }, 'bkw-dialog');
    },
    playWord(data) {
      let type = data;
      if (type === 'bdc_exam') {
        api.getExamModelList({
          courseId: this.courseId,
          unitId: this.currentUnitId,
        }).then(({ englishExamModelList }) => {
          this.wordExamInfo = englishExamModelList;
          if (this.wordExamInfo.list.length) {
            this.wordExamType = this.wordExamInfo.list[0].label;
            this.wordExamCount = this.wordExamInfo.list[0].value;
          }
          this.$refs['word-exam-dialog'].open();
        })
          .catch((error) => {
            if (error && error.code === 1033) {
              utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
                center: true,
              });
            } else {
              utils.error(error.message);
            }
          });
      } else if (type === 'bdc_wrong') {
        this.getQuizData(
          {
            courseId: this.courseId,
            unitId: this.currentUnitId,
            type,
          },
          'bdc-dialog',
        );
      } else {
        api.verifyWrongWord({
          courseId: this.courseId,
        }).then(({ verifyWrongWord }) => {
          if (verifyWrongWord.isHint) {
            const message = `系统检测到您本书目前有${verifyWrongWord.count}个易错词，您可对这些词进行强化训练！`;
            utils.alert(message, '易错词')
              .then((status) => {
                if (status === 'confirm') {
                  type = 'bdc_wrong';
                }
                this.getQuizData(
                  {
                    courseId: this.courseId,
                    unitId: this.currentUnitId,
                    type,
                  },
                  'bdc-dialog',
                );
              });
          } else {
            this.getQuizData(
              {
                courseId: this.courseId,
                unitId: this.currentUnitId,
                type,
              },
              'bdc-dialog',
            );
          }
        });
      }
    },
    onlineWordExam(type) {
      api.getExamOnlineModelList({ type: 'online' })
        .then(({ englishOnlineExamModelList }) => {
          this.BDCExamModeList = englishOnlineExamModelList;
          this.checkedBDCExamMode = [this.BDCExamModeList[0].value];
        });
      if (type === 'online') {
        this.isShowExamMode = true;
        return;
      }
      this.getQuizData(
        {
          courseId: this.courseId,
          unitId: this.currentUnitId,
          type: 'bdc_exam',
          mode: this.wordExamType,
          examType: type,
          callback: () => {
            this.$refs['bdc-dialog'].scene = 2;
          },
        },
        'bdc-dialog',
      );
    },
    getUnitList({ callback } = {}) {
      if (!this.currentCourse.type) return;
      api.getCourseUnitList({
        courseId: this.courseId,
        type: this.currentCourse.type,
      })
        .then(({ englishCourseUnitList }) => {
          this.unitList = [
            ...englishCourseUnitList.filter(unit => unit.isExperience),
            ...englishCourseUnitList.filter(unit => !unit.isExperience),
          ];
          const firstUnit = utils.Array.find(this.unitList, { status: 2 }, 'status')
            || utils.Array.find(this.unitList, { status: 0 }, 'status')
            || utils.Array.find(this.unitList, { status: 1 }, 'status');
          if (!this.currentUnitId) {
            this.currentUnitId = firstUnit.id;
          }
          if (this.currentCourse.type === 'BKW') {
            this.getModuleList(this.currentUnitId || firstUnit.id);
          }
          if (callback) {
            this.currentUnitId = firstUnit.id;
            this.$nextTick(() => {
              callback();
            });
          }
        });
    },
    getModuleList(unitId) {
      const container = document.querySelector('.module');
      const loadingInstance = utils.loading(container);
      api.getCourseModulelList({
        unitId,
      })
        .then(({ englishCourseModuleList }) => {
          this.currentUnitId = unitId;
          if (loadingInstance) {
            loadingInstance.close();
          }
          const moduleList = englishCourseModuleList.map((item) => {
            const { name, modeList } = item;
            const [view, review] = modeList;
            return {
              id: view.id,
              name,
              view,
              review,
            };
          });
          this.$set(this.modules, unitId, moduleList);
        })
        .catch((error) => {
          if (error && error.code === 1033) {
            utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              center: true,
            });
          } else {
            utils.error(error.message);
          }

          if (loadingInstance) {
            loadingInstance.close();
          }
        });
    },
    confirmOnlineExamMode() {
      this.isShowExamMode = false;
      this.getQuizData(
        {
          courseId: this.courseId,
          unitId: this.currentUnitId,
          type: 'bdc_exam',
          mode: this.wordExamType,
          examType: 'online',
          examMode: this.checkedBDCExamMode.join(','),
          callback: () => {
            this.$refs['bdc-dialog'].scene = 2;
          },
        },
        'bdc-dialog',
      );
    },
    replay({ quizzes, type }) {
      if (type === 'wrongs') {
        this.quizData = {
          id: this.courseId,
          type: 'learn_after_test',
          navigation: `${this.currentCourse.name}-错题再练`,
          title: this.currentUnit.name,
          subtitle: '',
          description: '',
          quizzes,
        };
        this.$refs['bdc-dialog'].open();
        this.$refs['bdc-dialog'].scene = 2;
      }
    },
    showBdcReport({ results, response }) {
      this.isShowBdcReport = true;
      this.reportResults = results.filter(result => !result.isRight)
        .map(result => ({
          ...result.ref,
          userAnswer: result.answer,
        }));
      this.reportInfo = {
        examId: response.examId,
        schoolName: response.schoolName,
        name: response.name,
        courseName: this.currentCourse.name,
        unitName: response.unitName,
        score: response.score,
        wordCount: response.wordCount,
        beforeWordCount: response.beforeWordCount,
        time: response.time,
        qrcode: response.qrcode,
        certificateId: response.examId,
      };
    },
    /* eslint-disable */
    getQuizData(
      {
        moduleId,
        type,
        courseId,
        unitId,
        mode,
        examType,
        examMode,
        callback,
        isCompleted,
      },
      dialog,
    ) {
      return api.getCourseData({
        modelId: moduleId,
        type,
        courseId,
        unitId,
        mode,
        examType,
        examMode,
      })
        .then(({ englishCourseData }) => {
          englishCourseData.moduleId = moduleId;
          this.quizData = englishCourseData;
          // 微课单独处理 模块完成标记微课已经完成 可拖拽进度
          this.quizData.quizzes.forEach((quiz) => {
            if (quiz.code === 'WK') {
              quiz.isCompleted = isCompleted;
            }
          });

          // const audios = this.quizData.quizzes.filter(quiz => quiz.audio);
          // audioPlayer.preload(audios.map(quiz => quiz.audio));

          const { message } = englishCourseData;

          if (message) {
            utils.alert(message, '提示', {
              confirmButtonText: '知道了',
              showClose: false,
            })
              .then(() => {
                this.$refs[dialog].open();
              });
          } else {
            this.$refs[dialog].open();
          }
          if (callback) {
            callback();
          }
        }, (error) => {
          if (error && error.code === 1033) {
            utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              center: true,
            });
          } else {
            utils.error(error.message);
          }
        });
    },
    submitQuizResult({
      data,
      seconds,
      callback,
      type,
      mode,
    }) {
      api.submitCourseResult({
        id: this.quizData.id,
        moduleId: this.quizData.moduleId,
        quizzes: data,
        type,
        seconds,
        mode,
      })
        .then(({ englishCourseResult }) => {
          if (callback) {
            callback(englishCourseResult);
          }
        }, (e) => {
          this.$refs['bkw-dialog'].error(e);
        });
    },
    handleContinue(type, scene) {
      let dialog;
      let params;
      if (this.currentCourse.type === 'BDC') {
        dialog = 'bdc-dialog';
        params = {
          courseId: this.courseId,
          unitId: this.currentUnitId,
          type: type || this.currentCourse.type,
        };
      } else {
        dialog = 'bkw-dialog';
        params = {
          moduleId: this.quizData.moduleId,
          type: type || this.quizData.type,
        };
      }
      this.getQuizData(params, dialog)
        .then(() => {
          if (this.quizData.type === 'test') {
            this.$refs[dialog].scene = scene || 1;
          } else {
            this.$refs[dialog].scene = scene || 2;
          }
        });
    },
    selectDownloadExamType(mode) {
      api.getExamOnlineModelList({ type: 'download' })
        .then(({ englishOnlineExamModelList }) => {
          this.BDCExamModeList = englishOnlineExamModelList;
          this.checkedBDCDownloadExamMode = this.BDCExamModeList[0].value;
          this.downloadExamType = mode;
          this.downloadExamDialogVisible = true;
        });
    },
    downloadWordExam() {
      this.downloadExamDialogVisible = false;
      const routeData = this.$router.resolve({
        name: 'print-exam',
        query: {
          type: 'BDC',
          quizType: 'bdc_exam',
          courseId: this.$route.params.courseId,
          unitId: this.currentUnitId,
          mode: this.wordExamType,
          examType: this.downloadExamType,
          examMode: this.checkedBDCDownloadExamMode,
        },
      });
      window.open(routeData.href, '_blank');
    },
    exportExamExcel() {
      this.downloadExamDialogVisible = false;
      api.getCourseData({
        type: 'bdc_exam',
        courseId: Number(this.$route.params.courseId),
        unitId: Number(this.currentUnitId),
        mode: this.wordExamType,
        examType: this.downloadExamType,
        examMode: this.checkedBDCDownloadExamMode,
      }).then(({ englishCourseData }) => {
        exportExcel.exportExcel(englishCourseData);
      });
    },
    closeDialog() {
      this.$refs['word-exam-dialog'].close();
    },
  },
  created() {
    this.getUnitList();
  },
  beforeRouteEnter(to, from, next) {
    const bookInfo = utils.storage('bookInfo');
    if (bookInfo) {
      next((vm) => {
        vm.currentCourse = bookInfo;
      });
    } else {
      next({
        path: '/learning-center/elective',
        replace: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .course {
    .bdc-btn {
      margin: 0 20px 0;
      .el-button {
        margin-bottom: 20px;
        margin-left: 0;
        width: 155px;
      }
    }
    .el-row {
      box-sizing: border-box;
      height: 82%;
      padding: 20px;
      .el-col {
        height: 100%;
      }
    }
    .title {
      height: 40px;
      line-height: 40px;
      background-color: $primary;
      margin: 0;
      padding-left: 10px;
      color: #fff;
      border-radius: 5px 5px 0 0;
    }
    .data-list {
      box-sizing: border-box;
      height: 100%;
      border: 1px solid $primary;
      border-radius: 0 0 5px 5px;
      overflow-y: auto;
      .empty {
        text-align: center;
      }
      ul {
        li {
          position: relative;
          height: 35px;
          line-height: 35px;
          padding: 0 12px;
          cursor: pointer;
          p {
            margin: 0;
          }
        }
      }
      &.unit {
        ul {
          li {
            .unit-name {
              margin: 0;
              padding-right: 60px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .status {
              position: absolute;
              right: 12px;
              top: 0;
              &.finished {
                color: $success;
              }
              &.underway {
                color: $primary;
              }
            }
            &:hover {
              background-color: rgba($primary, .2);
            }
            &.selected {
              background-color: rgba($primary, .2);
              font-weight: bold;
            }
          }
        }
      }
      &.module {
        position: relative;
        ul {
          li {
            box-sizing: border-box;
            border-bottom: 1px solid #eee;
            height: 45px;
            line-height: 45px;
            .module-name {
              margin: 0;
              padding-right: 140px;
            }
            .operation {
              position: absolute;
              right: 10px;
              top: 0;
            }
            &.active {
              color: red;
            }
          }
        }
        .bdc-module {
          box-sizing: border-box;
          display: flex;
          width: 100%;
          height: 100%;
          padding: 10px;
          div {
            position: relative;
            border-radius: 5px;
            cursor: pointer;
            user-select: none;
            &:hover {
              opacity: .9;
            }
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              color: #fff;
              font-size: 24px;
              transform: translate(-50%, -50%);
            }
          }
          .left {
            box-sizing: border-box;
            padding-right: 5px;
            width: 50%;
            height: 100%;
            line-height: 100%;
            background-color: #ffc12d;
            background-image: linear-gradient(45deg, #ffc12d, #facd64);
          }
          .right {
            box-sizing: border-box;
            padding-left: 5px;
            width: 50%;
            height: 100%;
            .item:first-child {
              height: 50%;
              background-color: #4edde2;
              background-image: linear-gradient(45deg, #4edde2, #69f2f6);
            }
            .item:last-child {
              margin-top: 5px;
              box-sizing: border-box;
              height: calc(50% - 5px);
              background-color: #a7e951;
              background-image: linear-gradient(45deg, #a7e951, #c0f877);
            }
          }
          .disable {
            background-color: $light-color!important;
            background-image: none!important;
            cursor: not-allowed;
          }
        }
      }
    }
    .word-exam-dialog {
      .word-centent {
        text-align: center;
        .name {
          margin: 80px 0 0;
          font-size: 2em;
        }
        .hint {
          margin: 60px;
          font-size: 1.5em;
        }
        .radio-group {
          .el-radio {
            margin: 0 60px;
            .el-radio__label {
              font-size: 16px;
            }
          }
        }
        .btn-control {
          margin: 60px 0 20px;
          .el-button {
            margin: 0 30px;
          }
        }
      }
    }
    .exam-dialog, .down-exam-dialog {
      .header {
        margin-bottom: 20px;
      }
      .footer-title {
        margin-top: 20px;
      }
    }
  }
</style>
